export default class ShopMenu extends HTMLElement {
    open: boolean = false

    menuEl: HTMLElement | null = null

    static get observedAttributes() {
        return ['open']
    }

    constructor() {
        super()

        this.menuEl = this.querySelector<HTMLElement>('aside[data-menu]') as HTMLElement

        // Event listeners
        ;(window as any).addEventListener('menu:toggle', this.handleMenu.bind(this))
    }

    get isOpen() {
        return this.open
    }

    set isOpen(value: boolean) {
        this.open = value
        this.setAttribute('open', value.toString())
        this.toggle()
    }

    handleMenu(evt: CustomEvent) {
        // @ts-ignore
        this.isOpen = evt.detail.open
    }

    handleClick(evt: Event) {
        evt.preventDefault()

        window.dispatchEvent(new CustomEvent('menu:toggle', { bubbles: true, detail: { open: false } }))
    }

    toggle() {
        if (this.isOpen) {
            // Menu
            this.menuEl?.classList.add('!left-0', '!opacity-100')

            // Body
            document.body.style.height = '100vh'
            document.body.style.overflow = 'hidden'
        } else {
            // Menu
            this.menuEl?.classList.remove('!left-0', '!opacity-100')

            // Body
            document.body.style.height = ''
            document.body.style.overflow = ''

            // Scroll to the top of the cart
            // setTimeout(() => {
            //     this.cartScrollEl?.scrollTo({ top: 0, behavior: 'instant' })
            // }, 250)
        }
    }
}

customElements.define('shop-menu', ShopMenu)
